import styled from 'styled-components';

const base = styled.div`
  display: flex;
  align-self: flex-start;
  justify-self: flex-start;
  justify-content: flex-start;
  align-items: center;
  margin: 0.5rem 0;
`;

const Frame = {
  Base: base,
};

export default Frame;
